'use client'

import Link from 'next/link'
import { useState } from 'react'
import { FaChevronDown } from 'react-icons/fa6'
import { capitalizeFirst } from '@/utils/capitalize'
import classNames from '@/utils/classNames'

interface Subcategory {
    name: string
    id: number | string
    href?: string
}
interface CategoryCardProps {
    id:  number | string
    name?: string
    href?: string
    image?: string | null
    title: string
    subcategories?: Subcategory[]
    extraCount?: number
}

export default function CategoryCard({
    href,
    image,
    title,
    subcategories = [
        { id: 1, name: 'Зима' },
        { id: 2, name: 'Лето' },
        { id: 3, name: 'Весна' },
        { id: 4, name: 'Осень' },
    ],
    extraCount,
}: CategoryCardProps) {
    console.log(image, 'Где картинка в категориях')
    const [expanded, setExpanded] = useState(false)

    const visibleItems = expanded ? subcategories : subcategories.slice(0, 5)

    return (
       <div className="group flex flex-col w-full rounded-xl border border-transparent bg-white p-3 transition-all duration-300 hover:bg-gray-50 hover:-translate-y-1">
                <Link href={href || '#'}>
<div
    className={classNames(
        "w-full h-56 flex items-center justify-center rounded-lg overflow-hidden transition-colors duration-300",
        {
            // есть картинка → всегда белый
            "bg-white": image,

            // нет картинки → белый + серый при hover всей карточки
            "bg-white group-hover:bg-gray-50": !image,
        }
    )}
>
                       {image ? (
                <img
                    src={image}
                    alt={title}
                    className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
                />
            ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-50 text-sm">
                
                </div>
            )}  
                    </div>
                </Link>
            <div className="mt-3">
                 <Link href={href ?? '/'}>
                <h2 className="text-2xl md:text-base font-semibold text-gray-900 line-clamp-2 hover:text-primary transition-colors">
                    {capitalizeFirst(title)}
                </h2>
                </Link>

                <ul className="mt-2 space-y-1 text-sm text-gray-600">
                    {visibleItems.map((item) => (
                        <li
                            key={item.id}
                            className="hover:text-black hover:underline"
                        >
                            <Link href={item.href ?? '/'}>
                           <h3 className="text-base font-normal"> {capitalizeFirst(item.name)}</h3>
                            </Link>
                        </li>
                    ))}
                </ul>
                {extraCount && subcategories.length > 5 && (
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className="mt-2 text-sm font-medium text-gray-900 hover:underline flex items-center"
                    >
                        {expanded
                            ? 'Скрыть'
                            : `Ещё ${subcategories.length - 5}`}
                        <FaChevronDown
                            className={`ml-1 w-4 h-4 transition-transform duration-300 ease-in-out ${
                                expanded ? 'rotate-180' : ''
                            }`}
                        />
                    </button>
                )}
            </div>
        </div>
    )
}
